import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Button, FlexColumn, FlexRow } from "@similarweb/ui-components";

export const Wrapper = styled(FlexColumn)`
    padding: 20px 16px 16px;
`;

export const Title = styled.div`
    ${setFontVariant("h5_2", colorsPalettes.carbon[500])}
    margin-bottom: 20px;
`;

export const Content = styled.p`
    ${setFontVariant("body1", colorsPalettes.carbon[400])}
    padding: 16px 0 24px;
    margin: 0;
`;

export const ButtonsWrapper = styled(FlexRow)`
    justify-content: right;
    width: 100%;
`;

export const StyledButton = styled(Button)`
    margin-right: 4px;
`;

export const ContentWrapper = styled.div`
    padding: 0 8px;
`;
